import { ApolloProvider, ApolloClient, InMemoryCache } from "@apollo/client";
import { loadErrorMessages, loadDevMessages } from "@apollo/client/dev";
import { BrowserRouter, Route } from "react-router-dom";
import { createUploadLink } from "apollo-upload-client";

import { PropertyListingsSearch } from "@components";
import { Home, TeamMember, PropertyListing, TeamMemberNew } from "@components/Pages";

import { ServerDataContext } from "../../contexts";
import type { ServerData } from "../../contexts";

import { Nav } from "./Nav";
import * as styles from "./Main.styles";

const Main = ({ csrfToken, ...rest }: ServerData) => {
  const headers: Record<string, string> = {};

  if (process.env.NODE_ENV === "development") {
    loadDevMessages();
    loadErrorMessages();
  }

  if (csrfToken) {
    headers["X-CSRF-Token"] = csrfToken;
  }

  const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: createUploadLink({ uri: "/graphql", headers }),
  });

  return (
    <ServerDataContext.Provider value={{ csrfToken, ...rest }}>
      <ApolloProvider client={client}>
        <BrowserRouter>
          <Nav />
          <div css={styles.content}>
            <Route component={ScrollToTop} />
            <Route path="/" children={<Home />} exact />
            <Route path="/team_member/new" children={<TeamMemberNew />} exact />
            <Route path="/team_members/:slug" children={<TeamMember />} />
            <Route path="/mls_listings" children={<PropertyListingsSearch />} exact />
            <Route path="/property_listings/:slug" children={<PropertyListing />} />
          </div>
        </BrowserRouter>
      </ApolloProvider>
    </ServerDataContext.Provider>
  );
};

const ScrollToTop = () => {
  window.scrollTo(0, 0);
  return null;
};

export { Main };
